import { Link } from "react-router-dom";
import { getAllArticles } from "@/mocks/articles";

export default function ArticlesGrid() {
  const articles = getAllArticles();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="font-heading italic text-accent-600 text-sm md:text-base">Knowledge Hub</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-2 leading-[1.15]">
            PandabuySpreadsheet
            <br />
            <span className="italic font-semibold text-accent-600">SEO Articles &amp; Guides</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg">
            In-depth guides, tips, and strategies for getting the most out of your pandabuy spreadsheet experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((art) => (
            <Link
              key={art.slug}
              to={`/article/${art.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 hover:-translate-y-1 hover:shadow-md cursor-pointer flex flex-col"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={art.image}
                  alt={art.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-background-50/90 backdrop-blur-sm text-[11px] font-semibold text-primary-700 border border-background-200/40">
                    {art.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-bold text-foreground-900 text-sm md:text-base leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {art.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 leading-relaxed line-clamp-2 flex-1">
                  {art.description}
                </p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/50">
                  <span className="text-[11px] text-foreground-400 flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {art.date}
                  </span>
                  <span className="text-[11px] text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i> {art.readTime}
                  </span>
                  <span className="text-[11px] text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i> {art.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}